export default "/imgs/promo-cross.png"